import { render, staticRenderFns } from "./Leadlike.vue?vue&type=template&id=226104ac&scoped=true&"
import script from "./Leadlike.vue?vue&type=script&lang=js&"
export * from "./Leadlike.vue?vue&type=script&lang=js&"
import style0 from "./Leadlike.vue?vue&type=style&index=0&id=226104ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226104ac",
  null
  
)

export default component.exports